import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function Header({
  user, darkMode, setDarkMode, handleLogout,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

    const handleLogoutClick = async () => {
    setIsLoggingOut(true); 
    await handleLogout(); 
    setIsLoggingOut(false); 
  };
  return (
    <header className="dashboard-header">
      <button type="button" onClick={() => setDarkMode(!darkMode)} className="theme-toggle">
        {darkMode ? '☀️' : '🌙'}
      </button>

      <div
        className="user-profile"
        role="button"
        tabIndex={0}
        onClick={() => setShowDropdown(!showDropdown)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setShowDropdown(!showDropdown);
          }
        }}
        aria-haspopup="true"
        aria-expanded={showDropdown}
      >
        <img
          src="/avatar.svg"
          alt="User Avatar"
          className="avatar"
        />
        <span className="username">{user?.name || 'User'}</span>
        <div className={`dropdown ${showDropdown ? 'show' : ''}`}>
          <ul>
            <li><button 
            type="button" 
            onClick={handleLogoutClick} 
            disabled={isLoggingOut}
            className="primary"
            >
             {isLoggingOut ? 'Logging out...' : 'Logout'}
             </button></li>
          </ul>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  darkMode: PropTypes.bool.isRequired,
  setDarkMode: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
};
